import type { QuestionFormValues, QuestionStep, ResultType, ScoreResult } from './questionFormTypes';

export const QUESTION_STEPS = [
  {
    key: 'budget',
    title: '예산은 어느 정도로 생각하고 계신가요?',
    description: '예복은 가격에 따라 제작 방식과 완성도가 달라집니다.',
    variant: 'plain',
    options: [
      {
        key: 'budget_low',
        label: '가성비 추구형',
        description: '합리적으로 준비하고 싶어요',
        meta: '50~100만원대',
        scores: {
          readyMade: 3,
          semiBespoke: 2,
          bespoke: 0,
          practical: 2,
        },
      },
      {
        key: 'budget_mid',
        label: '밸런스 중시형',
        description: '가격, 핏과 완성도 균형이 중요해요',
        meta: '100~250만원대',
        scores: {
          readyMade: 1,
          semiBespoke: 4,
          bespoke: 1,
          balanced: 3,
        },
      },
      {
        key: 'budget_high',
        label: '프리미엄',
        description: '오래 입을 한 벌을 제대로 만들고 싶어요',
        meta: '250만원 이상',
        scores: {
          readyMade: 0,
          semiBespoke: 1,
          bespoke: 5,
          classic: 2,
        },
      },
    ],
  },
  {
    key: 'bodyType',
    title: '정장 핏에서 고민되는 부분이 있나요?',
    description:
      '체형이나 핏 고민에 따라 기성복 / 반수제 / 수제 만족도가 달라질 수 있어요.',
    type: 'single',
    options: [
      {
        key: 'body_normal',
        label: '기성복도 크게 불편하지 않아요',
        description:
          '평균적인 체형이라 기본 수선만으로도 괜찮은 편이에요.',
        icon: 'ri-user-line',

        scores: {
          readyMade: 3,
          semiBespoke: 1,
        },
      },

      {
        key: 'body_shoulder',
        label: '어깨나 허리 핏이 잘 안 맞는 편이에요',
        description:
          '상체/허리 비율 때문에 정장 핏이 어색한 경우가 있어요.',
        icon: 'ri-ruler-line',

        scores: {
          semiBespoke: 4,
          bespoke: 2,
        },
      },

      {
        key: 'body_slim',
        label: '마른 체형이라 옷이 뜨는 경우가 많아요',
        description:
          '가슴이나 어깨 부분이 비어 보이거나 전체 핏이 뜨는 편이에요.',
        icon: 'ri-focus-3-line',

        scores: {
          semiBespoke: 3,
          bespoke: 2,
          classic: 1,
        },
      },

      {
        key: 'body_muscular',
        label: '운동 체형이라 상하체 밸런스 맞추기가 어려워요',
        description:
          '어깨나 허벅지 때문에 기성복 핏이 잘 안 맞는 편이에요.',
        icon: 'ri-boxing-line',

        scores: {
          semiBespoke: 4,
          bespoke: 4,
        },
      },

      {
        key: 'body_proportion',
        label: '기장이나 전체 비율이 중요한 편이에요',
        description:
          '키나 비율 때문에 전체 실루엣 균형을 중요하게 생각해요.',
        icon: 'ri-scissors-cut-line',

        scores: {
          semiBespoke: 3,
          classic: 2,
        },
      },
    ],
  },
  {
    key: 'usage',
    title: '예복을 얼마나 자주 입게 될 것 같나요?',
    description: '활용 빈도는 제작 방식 선택에 큰 영향을 줍니다.',
    options: [
      {
        key: 'usage_rare',
        label: '경조사 위주로 입을 것 같아요',
        description: '평소 정장은 거의 입지 않아요',
        scores: {
          readyMade: 2,
          semiBespoke: 3,
          bespoke: 0,
          practical: 3,
        },
      },
      {
        key: 'usage_work',
        label: '업무상 정장을 자주 입어요',
        description: '활용성과 내구성이 중요해요',
        scores: {
          readyMade: 3,
          semiBespoke: 2,
          bespoke: 2,
          minimal: 2,
        },
      },
      {
        key: 'usage_style',
        label: '평소에도 스타일 있게 자주 입고 싶어요',
        description: '핏과 분위기를 중요하게 생각해요',
        scores: {
          readyMade: 0,
          semiBespoke: 3,
          bespoke: 4,
          stylish: 3,
        },
      },
    ],
  },
  {
    key: 'schedule',
    title: '예식까지 얼마나 남아있나요?',
    description: '제작 방식에 따라 필요한 기간이 달라집니다.',
    options: [
      {
        key: 'schedule_short',
        label: '1개월 이내',
        description: '빠른 진행이 가장 중요해요',
        scores: {
          readyMade: 4,
          semiBespoke: 1,
          bespoke: -2,
          fast: 4,
        },
      },
      {
        key: 'schedule_mid',
        label: '2~3개월 정도',
        description: '가장 안정적으로 준비 가능한 시기예요',
        scores: {
          readyMade: 1,
          semiBespoke: 4,
          bespoke: 1,
          balanced: 2,
        },
      },
      {
        key: 'schedule_long',
        label: '4개월 이상 여유 있어요',
        description: '가봉과 디테일까지 충분히 조율 가능해요',
        scores: {
          readyMade: 0,
          semiBespoke: 2,
          bespoke: 5,
          classic: 3,
        },
      },
    ],
  },
  {
    key: 'photo',
    title: '웨딩 촬영도 함께 준비하시나요?',
    description: '촬영 대여복 구성은 업체마다 차이가 큽니다.',
    options: [
      {
        key: 'photo_yes',
        label: '촬영용 대여도 중요해요',
        description: '턱시도와 다양한 스타일을 입어보고 싶어요',
        scores: {
          readyMade: 0,
          semiBespoke: 3,
          bespoke: 1,
          event: 4,
        },
      },
      {
        key: 'photo_no',
        label: '본식 예복 위주로 생각하고 있어요',
        description: '실사용성과 활용도가 중요해요',
        scores: {
          readyMade: 2,
          semiBespoke: 2,
          bespoke: 2,
          minimal: 2,
        },
      },
    ],
  },
  {
    key: 'style',
    title: '어떤 스타일이 더 끌리시나요?',
    description: '같은 수트라도 분위기는 꽤 달라집니다.',
    options: [
      {
        key: 'style_trendy',
        label: '슬림하고 트렌디한 느낌',
        description: '사진에서 세련된 분위기를 원해요',
        scores: {
          semiBespoke: 2,
          stylish: 4,
        },
      },
      {
        key: 'style_classic',
        label: '클래식하고 오래 봐도 안정적인 느낌',
        description: '유행을 덜 타는 스타일이 좋아요',
        scores: {
          bespoke: 2,
          classic: 4,
        },
      },
      {
        key: 'style_simple',
        label: '깔끔하고 활용도 높은 느낌',
        description: '결혼 이후에도 자연스럽게 입고 싶어요',
        scores: {
          readyMade: 2,
          practical: 3,
          minimal: 3,
        },
      },
    ],
  },
] satisfies QuestionStep[];

export const RESULT_TYPES = [
  {
    key: 'readyMade',
    title: '활용 중심 실속형',
    recommendation: '기성복 + 수선 조합',
    summary: '웨딩 이후까지 생각하면 활용도가 가장 중요해요.',
  },
  {
    key: 'semiBespoke',
    title: '밸런스형 신랑',
    recommendation: '반수제',
    summary: '가장 많은 신랑님들이 선택하는 안정적인 방식이에요.',
  },
  {
    key: 'bespoke',
    title: '클래식 장인형',
    recommendation: '비스포크 / 수제',
    summary: '시간을 들여 내 체형에 맞는 한 벌을 만드는 방식이에요.',
  },
  {
    key: 'fast',
    title: '일정 우선형',
    recommendation: '빠른 반수제 / 기성복',
    summary: '지금은 안정적인 일정 관리가 더 중요할 수 있어요.',
  },
  {
    key: 'event',
    title: '촬영 중심형',
    recommendation: '대여 특화 반수제',
    summary: '본식뿐 아니라 촬영 결과물까지 중요하게 보는 타입이에요.',
  },
  {
    key: 'practical',
    title: '미니멀 실용형',
    recommendation: '활용도 높은 기성복',
    summary: '결혼식 하루보다 이후 활용까지 생각하는 타입이에요.',
  },
  {
    key: 'stylish',
    title: '스타일 우선형',
    recommendation: '트렌디 반수제',
    summary: '착용감보다 분위기와 실루엣 만족도가 중요한 타입이에요.',
  },
  {
    key: 'classic',
    title: '클래식 취향형',
    recommendation: '비스포크 / 클래식 수트',
    summary: '10년 뒤에도 어색하지 않은 스타일을 선호하는 타입이에요.',
  },
  {
    key: 'minimal',
    title: '합리적 투자형',
    recommendation: '가성비 중심 반수제',
    summary: '가장 효율 좋은 선택지를 찾는 타입이에요.',
  },
] satisfies ResultType[];

export const INITIAL_QUESTION_FORM_VALUES = QUESTION_STEPS.reduce<QuestionFormValues>((acc, step) => {
  acc[step.key] = null;
  return acc;
}, {});

export function getSelectedOption(step: QuestionStep, selectedKey: string | null) {
  if (!selectedKey) return null;
  return step.options.find((option) => option.key === selectedKey) ?? null;
}

export function calculateQuestionResult(values: QuestionFormValues): ScoreResult {
  const scores: Record<string, number> = {};

  QUESTION_STEPS.forEach((step) => {
    const selectedOption = getSelectedOption(step, values[step.key]);
    if (!selectedOption) return;

    Object.entries(selectedOption.scores).forEach(([scoreKey, score]) => {
      scores[scoreKey] = (scores[scoreKey] ?? 0) + score;
    });
  });

  const sortedScores = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const [topKey, topScore] = sortedScores[0] ?? [null, 0];
  const resultType = RESULT_TYPES.find((result) => result.key === topKey) ?? null;
  
  return {
    scores,
    topKey,
    topScore,
    resultType,
  };
}
